export default "__VITE_ASSET__Bmlpee1P__"